<template>
	<div :class="`notification block ${type}`">
		<div class="notification-close">
			<span class="fas fa-times" @click="close"></span>
		</div>
		<div class="notification-title">{{ title }}</div>
		<div class="notification-content" v-html="text"></div>
	</div>
</template>

<script>
export default {
	name: 'BlockNotification',
	props: {
		text: String,
		title: String,
		type: String
	},
	methods: {
		close () {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
	.notification.block {
		position: relative;
		display: block;
		min-height: 35px;
		border: 1px solid #CCC;
		background-color: #FEFEFE;
		color: #333;

		&.warning {
			border-color: #CCCE60;
			background-color: #FBF9CE;
		}

		&.error {
			border-color: #D48787;
			background-color: #FDCECE;
		}

		&.info {
			border-color: #8C87D4;
			background-color: #CEE2FD;
		}

		&.success {
			border-color: #92C18C;
			background-color: #CEFDD5;
		}

		.notification-close {
			position: absolute;
			top: 5px;
			right: 10px;
			cursor: pointer;
		}

		.notification-title {
			padding: 5px;
			font-weight: bold;
		}

		.notification-content {
			padding: 5px;
		}
	}
</style>
